import * as React from 'react';
import { currentPageLoadFailure } from '@avensia/excite';
import { addToDataLayer, type DataLayerEvent } from '..';

export function useErrorTracking() {
  React.useEffect(
    () =>
      currentPageLoadFailure.on(async error => {
        const event: DataLayerEvent = {
          event: 'error',
          event_info: {
            page_location: error?.url.toString(),
            error_message: error?.errorStatus,
            fatal: true,
          },
        };

        addToDataLayer(event);
      }),
    [],
  );
}
